import React from "react";
import { IconProps } from "../../components/Icon";

export default function DeleteIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "16"}
      viewBox="0 0 14 16"
    >
      <path
        id="Path_10238"
        data-name="Path 10238"
        d="M1.813-.125h.75A.375.375,0,0,0,2.938-.5V-7.25a.375.375,0,0,0-.375-.375h-.75a.375.375,0,0,0-.375.375V-.5A.375.375,0,0,0,1.813-.125Zm5.125-10.5H4.362L3.3-12.4a1.663,1.663,0,0,0-1.286-.728H-1.138a1.663,1.663,0,0,0-1.286.728l-1.063,1.772H-6.062a.5.5,0,0,0-.5.5v.5a.5.5,0,0,0,.5.5h.5v10.5a1.5,1.5,0,0,0,1.5,1.5h9a1.5,1.5,0,0,0,1.5-1.5v-10.5h.5a.5.5,0,0,0,.5-.5v-.5A.5.5,0,0,0,6.937-10.625Zm-8.13-.909a.208.208,0,0,1,.161-.091H1.906a.208.208,0,0,1,.161.091l.546.909H-1.738ZM4.938,1.375h-9v-10.5h9Zm-6.625-1.5h.75A.375.375,0,0,0-.562-.5V-7.25a.375.375,0,0,0-.375-.375h-.75a.375.375,0,0,0-.375.375V-.5A.375.375,0,0,0-1.687-.125Z"
        transform="translate(6.563 13.125)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
